import React, { Component } from 'react';
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import PBFormRender from './PBFormRender'
import { formFieldsOptions } from './common.js'
import { loadInitialValue } from './actions/index.js'

class InsideAddonForm extends Component {

  render(){
    const { handleSubmit, state, showButtons } = this.props
    var addonOps = formFieldsOptions( state.sppbForm.insideForm )

    return(
      <form className="sppb-inside-form" onSubmit={ handleSubmit }>
        <div id="sp-pagebuilder-modal-top-actions" className="sp-modal-top-action-btns">
          {
            showButtons &&
            <button type="submit" className="sp-pagebuilder-btn sp-pagebuilder-btn-success">
              <i className="fa fa-check-square-o"></i> Apply
            </button>
          }

          {
            showButtons
            ?
            <a
              href="#"
              className="sp-pagebuilder-btn sp-pagebuilder-btn-default sp-pagebuilder-cancel-btn"
              onClick ={(e)=>{
                e.preventDefault();
                this.props.cancelInsideAddonForm();
              }}
            >Cancel</a>
            :
            <a
              href="#"
              className="sp-pagebuilder-btn sp-pagebuilder-btn-success"
              onClick ={(e)=>{
                e.preventDefault();
                this.props.cancelInsideAddonForm();
              }}
            ><i className="fa fa-check-square-o"></i> Apply</a>
          }
          
          
        </div>
        <PBFormRender addonOps={ addonOps } formName="insideForm" />
        <div id="sp-pagebuilder-modal-actions" className="sp-pagebuilder-modal-actions">
          <button type="submit" className="sp-pagebuilder-btn sp-pagebuilder-btn-success">
            <i className="fa fa-check-square-o"></i> Apply
          </button>
          <a
            href="#"
            className="sp-pagebuilder-btn sp-pagebuilder-btn-default"
            onClick ={(e)=>{
              e.preventDefault();
              this.props.cancelInsideAddonForm();
            }}
          >
            <i className="fa fa-times-circle"></i>
            <span> Cancel</span>
          </a>
        </div>
      </form>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    state,
    initialValues: state.sppbForm.insideForm.values
  };
}

const mapDispatchToProps = ( dispatch ) => {
  return {
    cancelInsideAddonForm: () => {
      dispatch( { type: 'CANCEL_ADDON_IN_FORM' } )
    }
  }
}

InsideAddonForm = reduxForm({
  form: 'insideAddonForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(InsideAddonForm);

InsideAddonForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(InsideAddonForm);

export default InsideAddonForm;



// WEBPACK FOOTER //
// ./src/helpers/form/InsideAddonForm.js